import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.marginBase * 2,
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center',
    flexDirection: 'row',
    padding: [theme.marginBase * 4, theme.marginBase * 2],
    [theme.media.largeScreen]: {
      padding: [theme.marginBase * 4, theme.marginBase * 7],
      justifyContent: 'flex-start',
    },
  },
  containerCenter: {
    justifyContent: 'center',
  },
}));

interface Props {
  children?: React.ReactNode;
  noParticipation?: boolean;
}

export const StudiesCardContainer = ({ children, noParticipation }: Props) => {
  const classes = useStyles();

  return (
    <div
      className={classnames(classes.container, {
        [classes.containerCenter]: noParticipation,
      })}
    >
      {children}
    </div>
  );
};
